import React from 'react';

import { locale } from '@trqk/utils';

import { DetectionNotifications } from './components';

interface NotificationsProps {
    userId: string;
}

export const Notifications = ({ userId }: NotificationsProps): JSX.Element => (
    <div className="px-12 py-10 bg-white rounded-lg">
        <h2 className="text-xl mb-6">
            {locale.enUS.ACCOUNT.SECTIONS.NOTIFICATIONS.TITLE}
        </h2>
        <DetectionNotifications userId={userId} />
    </div>
);
